<template>
    <div style="width:50%;margin:auto;">
        <div v-if="value" class="slide-bottom" >
            <EspError icon="mdi-close" :iconColor="iconColor" text=""/>
        </div>
    </div>
</template>

<script>
    import EspError from './EspError.vue'
    export default {
        components:{
            EspError
        },
        props:{
            value:{
                type:Boolean,
                default:false
            },
            iconColor:{
                type:String
            }
        },
        methods: {
            
        },  
    }
</script>

<style lang="scss" scoped>
.slide-bottom {
	-webkit-animation: slide-bottom 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
            animation: slide-bottom 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

@-webkit-keyframes slide-bottom {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
            opacity: 1;
  }
  100% {
    -webkit-transform: translateY(100px);
            transform: translateY(100px);
            opacity: 0.3;
  }
}
@keyframes slide-bottom {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
            opacity: 1;
  }
  100% {
    -webkit-transform: translateY(100px);
            transform: translateY(100px);
            opacity: 0.3;
  }
}
</style>